import React from 'react';
import { HashRouter as BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import './App.css';

import { CartProvider } from './context/CartContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';

// Storefront pages
import Home from './pages/Home';
import Menu from './pages/Menu';
import Combos from './pages/Combos';
import Reviews from './pages/Reviews';
import Contact from './pages/Contact';

// Admin pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import Orders from './pages/admin/Orders';
import AllProducts from './pages/admin/AllProducts';
import AddProduct from './pages/admin/AddProduct';
import Categories from './pages/admin/Categories';
import Coupons from './pages/admin/Coupons';
import AdminReviews from './pages/admin/AdminReviews';
import MediaBranding from './pages/admin/MediaBranding';
import AdminSettings from './pages/admin/Settings';
import Reports from './pages/admin/Reports';
import StockManagement from './pages/admin/StockManagement';

// Protected route
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
};

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <SettingsProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors expand={false} />
            <Routes>
              {/* Storefront */}
              <Route path="/" element={<Home />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/combos" element={<Combos />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/contact" element={<Contact />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={
                <ProtectedRoute><AdminLayout /></ProtectedRoute>
              }>
                <Route index element={<Navigate to="/admin/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="orders" element={<Orders />} />
                <Route path="products" element={<AllProducts />} />
                <Route path="products/new" element={<AddProduct />} />
                <Route path="products/:id/edit" element={<AddProduct />} />
                <Route path="categories" element={<Categories />} />
                <Route path="coupons" element={<Coupons />} />
                <Route path="reviews" element={<AdminReviews />} />
                <Route path="media" element={<MediaBranding />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="reports" element={<Reports />} />
                <Route path="stock" element={<StockManagement />} />
              </Route>

              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </SettingsProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
